<template>
   <div class="listing d-flex flex-column vh-100">
      <!-- navbar -->
      <div class="listing-navbar bg-primary d-flex align-items-center gap-3 shadow-sm mb-auto p-3">
         <a  @click="goBack()"><i class="bi bi-arrow-left text-white fs-5"></i></a>
         <a   >
            <div class="d-flex align-items-center gap-2">
               <span class="bg-white rounded p-1">
                <img :src="$asset_path+'search.png'" alt="" class="img-fluid"> 
               
               </span>
               <div>
                  <h6 class="fw-bold text-white mb-0">{{current_cat?current_cat.name:'Search Results'}}</h6>
                  <p class="text-white-50 small m-0">{{((events?events.length:0)+(food?food.length:0)+(jobs?jobs.length:0)+(business?business.length:0)+(properties?properties.length:0))??0}} Items</p>
               </div>
            </div>
         </a>
         <!--<div class="d-flex align-items-center gap-2 ms-auto">-->
         <!--   <a href="#" class="link-dark bg-light rounded-circle user-icon" data-bs-toggle="offcanvas" data-bs-target="#searchoffcanvas"-->
         <!--      aria-controls="searchoffcanvas"><i-->
         <!--      class="icofont-search-1 fs-6"></i></a>-->
         <!--   <a class="toggle" href="#">-->
         <!--   <b class="link-dark bg-light rounded-circle user-icon">-->
         <!--   <i class="bi bi-list d-flex m-0 h4"></i>-->
         <!--   </b>-->
         <!--   </a>-->
         <!--</div>-->
      </div>
      <!-- body -->
      <div class="vh-100 my-auto overflow-auto p-1 light_gray">
         <div class=" ">
            
            <div class=" ">
               <div class="bg-white rounded shadow-sm">
                  <div class="tab-content" id="v-pills-tabContent">
                     <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab" tabindex="0">
                        <!--<div class="border-bottom p-2">-->
                        <!--   <div class="rounded-3 ps-3 shadow-sm d-flex gap-1 align-items-center bg-success bg-gradient justify-content-between">-->
                        <!--      <div class="py-3">-->
                        <!--         <small class="text-white-50 d-flex align-items-center"><i class="bi bi-basket me-1 d-flex"></i> UPTO</small>-->
                        <!--         <h3 class="fw-bold text-warning mb-0">20% OFF</h3>-->
                        <!--         <p class="text-white mb-2">Fruits & Vegetables</p>-->
                        <!--         <a href="listing.html" class="btn btn-light text-success fw-bold rounded-3 shadow-sm btn-sm border-0">SHOP NOW</a>-->
                        <!--      </div>-->
                        <!--      <img src="img/banner2.png" alt="" class="img-fluid mt-auto osahan-offer-banner-2">-->
                        <!--   </div>-->
                        <!--   <p class="text-muted pt-2 mb-0"><span class="fw-bold text-dark">42 items</span> in Hot Deals-->
                        <!--   </p>-->
                        <!--</div>-->

                    <!-- event -->
                     <small v-if="searchQuery" class="searchQuery">You are searching for "{{searchQuery}}"</small>
                        <div class="row g-0" v-if="events">
                             <div class="d-flex align-items-center justify-content-between p-3 pb-3 light_gray">
                               <h5 class="fw-bold text-black mb-0">Events</h5>
                               <!-- <a class="text-primary" href="eventlist">View all<i class="icofont-rounded-right"></i></a> -->
                            </div>
                           <div class="col-6 border-end" v-for="(event_row, i) in events" :key="i">
                               
                              <div class="card bg-transparent border-0 p-2 h-100">
                                <router-link :to="`/singleeventlist?id=${event_row.id}&name=event`" >
                                   <div class="bg-light rounded-4 product-box" :style="'background:url('+$asset_path+'event/'+event_row.img+') top center / cover no-repeat'"></div>
                                 
                                  <div class="bg-info position-absolute top-0 text-white osahan-badge text-center mx-3">
                                    <b>Event</b> 
                                 </div>
                                 <div class="card-body p-0 mb-3">
                                    <small class="text-muted">{{ event_row.name }}</small>
                                    <p class="card-title fw-bold mb-0">
                                       {{ event_row.description.split(' ').slice(0, 10).join(' ') }}...
                                     </p>                                     
                                 </div>
                                 <div
                                    class="card-footer bg-transparent border-0 d-flex align-items-end justify-content-between p-0">
                                    <div>
                                       <p class="text-muted mb-1">{{ event_row.time?'Time :'+event_row.time:'' }}</p>
                                       <del class="text-muted small">₹{{ event_row.cost }}</del>
                                       <p class="fw-bold m-0">₹{{ event_row.cost }}</p>
                                       <p class="text-muted mb-1">{{ event_row.location }}</p>
                                    </div>
                                    <router-link :to="`/singleeventlist?id=${event_row.id}&name=event`" 
                                       class="btn btn-outline-success btn-sm border-dark-subtle fw-bold rounded-3 shadow-sm px-3">View</router-link >
                                 </div>
                                 </router-link >
                              </div>
                           </div>
                           </div>

                           <!--  event-->



                          <!-- business -->

                          <div class="row g-0" v-if="businesslisting">
                             <div class="d-flex align-items-center justify-content-between p-3 pb-3 light_gray">
                               <h5 class="fw-bold text-black mb-0">Business</h5>
                            </div>
                           <div class="col-6 border-end" v-for="(business_row, i) in businesslisting" :key="i">
                              <div class="card bg-transparent border-0 p-2 h-100">
                                 <router-link :to="`/singleeventlist?id=${business_row.id}&name=business`" >
                                      <div class="bg-light rounded-4 product-box" :style="'background:url('+$asset_path+'business/'+business_row.img+') top center / cover no-repeat'"></div>
                                    <!--<img :src="$asset_path+'business/'+listings.img"  alt="" class="img-fluid w-75 d-block mx-auto">-->
                                 </router-link >
                                 <div class="card-body p-0 mb-3">
                                    <small class="text-muted">{{ business_row.name }}</small>
                                    <p class="card-title fw-bold mb-0">{{ business_row.catname }}</p>
                                 </div>
                                 <div
                                    class="card-footer bg-transparent border-0 d-flex align-items-end justify-content-between p-0">
                                    <div>
                                       <p class="text-muted mb-1">{{ business_row.description }}</p>
                                       <p class="text-muted mb-1">
                                          <i class="bi bi-telephone"></i>
                                          <a href="tel:{{ business_row.mobile }}">{{ business_row.mobile }}</a>
                                        </p>                                        
                                    </div>
                                   <router-link :to="`/singleeventlist?id=${business_row.id}&name=business`" 
                                       class="btn btn-outline-success btn-sm border-dark-subtle fw-bold rounded-3 shadow-sm px-3">View</router-link >
                                 </div>
                              </div>
                           </div>
                           </div>

                           <!-- business -->

             
                            <!-- property -->

                     
                        <div class="row g-0" v-if="properties">
                             <div class="d-flex align-items-center justify-content-between p-3 pb-3 light_gray">
                               <h5 class="fw-bold text-black mb-0">Properties</h5>
                            </div>
                           <div class="col-6 border-end" v-for="(properties_row, i) in properties" :key="i">
                              <div class="card bg-transparent border-0 p-2 h-100">
                                  <router-link :to="`/singleeventlist?id=${properties_row.id}&name=property`" >
                                      <div class="bg-light rounded-4 product-box" :style="'background:url('+$asset_path+'property/'+properties_row.img+') top center / cover no-repeat'"></div>
                                    <!--<img :src="$asset_path+'properties/'+properties.img"  alt="" class="img-fluid w-75 d-block mx-auto">-->
                                 </router-link >
                                 <div class="card-body p-0 mb-3">
                                    <small class="text-muted">{{ properties_row.name }}</small>
                                    <p class="card-title fw-bold mb-0">{{ properties_row.description }}</p>
                                 </div>
                                 <div
                                    class="card-footer bg-transparent border-0 d-flex align-items-end justify-content-between p-0">
                                    <div>
                                       <p class="text-muted mb-1">{{ properties_row.feet?properties_row.feet+' sq/feet':'' }} </p>
                                       <del class="text-muted small">₹{{ properties_row.cost }}</del>
                                       <p class="fw-bold m-0">₹{{ properties_row.cost }}</p>
                                       <p class="text-muted mb-1"><i class="bi bi-telephone"></i>{{ properties_row.contact }}</p>
                                    </div>
                                   <router-link :to="`/singleeventlist?id=${properties_row.id}&name=property`" 
                                       class="btn btn-outline-success btn-sm border-dark-subtle fw-bold rounded-3 shadow-sm px-3">View</router-link >
                                 </div>
                              </div>
                           </div>
                           </div>

                             <!-- food --> 
  
                        <div class="row g-0" v-if="food">
                             <div class="d-flex align-items-center justify-content-between p-3 pb-3 light_gray">
                               <h5 class="fw-bold text-black mb-0">Food</h5>
                            </div>
                           <div class="col-6 border-end" v-for="(food_row, i) in food" :key="i">
                              <div class="card bg-transparent border-0 p-2 h-100">
                                 <router-link :to="`/singleeventlist?id=${food_row.id}&name=food`" >
                                      <div class="bg-light rounded-4 product-box" :style="'background:url('+$asset_path+'food/'+food_row.img+') top center / cover no-repeat'"></div>
                                    <!--<img :src="$asset_path+'food/'+food.img"  alt="" class="img-fluid w-75 d-block mx-auto">-->
                                 </router-link >
                                 <div class="card-body p-0 mb-3">
                                    <small class="text-muted">{{ food_row.name }}</small>
                                    <p class="card-title fw-bold mb-0">{{ food_row.description }}</p>
                                 </div>
                                 <div
                                    class="card-footer bg-transparent border-0 d-flex align-items-end justify-content-between p-0">
                                    <div>
                                       <p v-if="food.feet" class="text-muted mb-1">{{ food_row.feet }} sq/feet</p>
                                       <del v-if="food.cost"class="text-muted small">₹{{ food_row.cost }}</del>
                                       <p v-if="food.cost"class="fw-bold m-0">₹{{ food_row.cost }}</p>
                                       <p v-if="food.contact" class="text-muted mb-1"><i class="bi bi-telephone"></i>{{ food_row.contact }}</p>
                                    </div>
                                    <router-link :to="`/singleeventlist?id=${food_row.id}&name=food`" 
                                       class="btn btn-outline-success btn-sm border-dark-subtle fw-bold rounded-3 shadow-sm px-3">View</router-link >
                                 </div>
                              </div>
                           </div>
                           </div>


                       


                           <div class="row g-0" v-if="jobs">
                             <div class="d-flex align-items-center justify-content-between p-3 pb-3 light_gray">
                               <h5 class="fw-bold text-black mb-0">Jobs</h5>
                            </div>
                              <div class="col-6 border-end" v-for="(data_row, i) in jobs" :key="i">
                                 <div class="card bg-transparent border-0 p-2 h-100">
                                    <router-link :to="`/singleeventlist?id=${data_row.id}&name=job`" class="link-dark">
                                          <div class="card bg-transparent border-0 overflow-hidden h-100 p-1">
                                             
                                           
                                                <div class="bg-light rounded-4 product-box" :style="'background:url('+$asset_path+'jobs/'+data_row.img+') top center / cover no-repeat'">
                                                   <!--<img :src="$asset_path+'event/'+event.img"  alt="" class="img-fluid w-75 d-block mx-auto">-->
                                                </div>
                                            
                                             <div class="bg-info position-absolute top-0 text-white osahan-badge text-center mx-3">
                                                {{data_row.jobtype}} 
                                             </div>
                                             <div class="card-body p-0">
                                                <small class="text-muted twoline"> {{data_row.title}}</small>
                                                <h6 class="card-title fw-bold twoline"><i class="bi bi-building-fill-check"></i> {{data_row.companyname}}</h6>                         
                                                <!-- <p class="card-text text-muted">100 g x 2</p> -->
                                             </div>
                                             <div
                                                class="card-footer bg-transparent border-0 d-flex align-items-center justify-content-between p-0">
                                                <div>
                                                   <!-- <del class="small text-muted">$108</del> -->
                                                   <!-- <h6 class="fw-bold m-0">
                                                      <i class="bi bi-telephone"></i>
                                                      <a :href="'tel:' + data_row.contact" class="text-decoration-none text-dark">{{ data_row.contact }}</a>
                                                    </h6> -->
                                                    <p class="text-muted">Experience: {{data_row.experienceyear}}</p> 
                                                    <p class="text-muted twoline"><i class="bi bi-geo-alt-fill"></i> {{data_row.joblocation}}</p>   
                                                </div>
                                                 <router-link :to="`/singleeventlist?id=${data_row.id}&name=job`" class="btn btn-outline-success fw-bold rounded-3 shadow-sm btn-sm">View</router-link> 
                                                
                                             </div>
                                          </div>
                                       </router-link>
                                 </div>
                              </div>
                              </div>




                          
                        </div> 
                     
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div> 
</template>
<style>
.weather-container {
  text-align: center;
    font-family: Arial, sans-serif;
    padding: 4px 20px;
    background: #f4f4f4;
    margin: auto;
    border-radius: 10px;
}
.bg_card{
  background: #ededec;
    margin: 10px 0px;
    padding-bottom: 10px;
}

.searchQuery{
        position: fixed;
        background: white;
        width: -webkit-fill-available;
        z-index: 9999;
        margin-top: 0;
        color: red;
}
</style>

<script> 
import axios from "@/plugins/axios";  

export default {
 name: 'searchbar',
 components: { 
 },
 mounted() {

   this.getBasic(this.$route.query.string);
   
        
},
 data() {
   return {
     loading:false,
     error:null,
     isUserLogged:false,
     profile:[],
     categories:[],
     businesslisting:[],
     events:[],
     news:[],
     jobs:[],
     food:[],
     searchQuery: "", // Stores the search input value
     properties:[],
       current_temperature:0,
    


   }
 },
 methods:{
   goBack() {
      if (this.$route.query.from) {
        this.$router.push(this.$route.query.from);
      } else {
        this.$router.go(-1);
      }
    },
 
      getBasic(string="") {
         var self = this;
         axios.post("getfilterlist",{_string:string})
            .then((response) => {

            self.events = response.data.events;
            self.news = response.data.news;
            self.jobs = response.data.jobs;
            self.food = response.data.food; 
            self.businesslisting = response.data.businesslisting;
            self.properties = response.data.properties;
            self.searchQuery = response.data._string;
            })
            .then(() => {
  
            })
         }



    




 }
}






</script>
